<template>
  <section class="mars-section">
    <div class="container">
      <img
        :src="require('@/assets/image/mars-section/mars.png')"
        alt="mars"
        class="mars" id="mars">
        <div class="about">
          <div class="about__heading">
            <span>№8</span> Нас ждёт <br>Марс
          </div>
          <div class="about__text">
            Компания Space X Илона Маска успешно запустила
            в космос ракету Falcon 9, но что это значит? Это
            первая ракета многоразового применения, которая
            должна в корне изменить наше отношение к космосу.
            Первый туристический полет на орбиту Земли
            запланирован на 2021 год, а полет человека
            на Марс — на 2024-й
          </div>
        </div>
    </div>
    <div class="shuttle-container">
      <img
        :src="require('@/assets/image/mars-section/space.png')"
        alt="shuttle"
        class="shuttle">
      <div class="fire-block">
        <img
          :src="require('@/assets/image/mars-section/fire.gif')"
          alt="fire"
          class="fire fire__1">
        <img
          :src="require('@/assets/image/mars-section/fire.gif')"
          alt="fire"
          class="fire fire__2">
        <img
          :src="require('@/assets/image/mars-section/fire.gif')"
          alt="fire"
          class="fire fire__3">
      </div>
    </div>
  </section>
</template>

<script>
import { gsap, TweenMax } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'v-mars-section',
  mounted() {
    const timelineMars = gsap.timeline({
      scrollTrigger: {
        trigger: '.mars-section',
        start: '-=50%',
        end: 'bottom',
        scrub: 2,
        onUpdate: (self) => {
          console.log('progress4:', self.progress);
          const mars = document.getElementById('mars');
          const marsSection = document.getElementsByClassName('mars-section');
          if (self.progress < 0.133 && mars.classList.contains('activate')) {
            mars.classList.remove('activate');
            TweenMax.to('.mars', {
              scale: 1.3,
              rotate: '0deg',
            });
            TweenMax.to('.mars-section .about', {
              opacity: 0,
            });
            return;
          }
          if (self.progress > 0.133 && !mars.classList.contains('activate')) {
            mars.classList.add('activate');
            TweenMax.to('.mars', {
              opacity: 1,
              scale: 1.3,
              rotate: '120deg',
            });
            TweenMax.to('.mars-section .about', {
              opacity: 1,
            });
          }
          if (self.progress > 0.28 && mars.classList.contains('activate') && !mars.classList.contains('activate__bg')) {
            mars.classList.add('activate__bg');
            marsSection[0].style.background = '#001424';
          }
          if (self.progress < 0.28 && mars.classList.contains('activate') && mars.classList.contains('activate__bg')) {
            mars.classList.remove('activate__bg');
            marsSection[0].style.background = 'inherit';
          }
          if (self.progress > 0.48 && mars.classList.contains('activate') && !mars.classList.contains('activate__bg2')) {
            mars.classList.add('activate__bg2');
            document.body.style.background = '#F4F4F4';
          }
          if (self.progress < 0.48 && mars.classList.contains('activate') && mars.classList.contains('activate__bg2')) {
            mars.classList.remove('activate__bg2');
            document.body.style.background = '#001424';
          }
          if (self.progress > 0.6 && mars.classList.contains('activate') && !mars.classList.contains('activate__2')) {
            mars.classList.add('activate__2');
            TweenMax.to('.mars-section .about', {
              opacity: 0,
            });
          }
          if (self.progress < 0.6 && mars.classList.contains('activate') && mars.classList.contains('activate__2')) {
            mars.classList.remove('activate__2');
            TweenMax.to('.mars-section .about', {
              opacity: 1,
            });
          }
          if (self.progress > 0.80 && !mars.classList.contains('activate__3')) {
            mars.classList.add('activate__3');
            TweenMax.to('.mars', {
              opacity: 0,
              y: '-250px',
              rotate: '180deg',
            });
          }
          if (self.progress < 0.80 && mars.classList.contains('activate__3')) {
            mars.classList.remove('activate__3');
            TweenMax.to('.mars', {
              opacity: 1,
              y: '0px',
              rotate: '120deg',
            });
            TweenMax.to('.mars-section .about', {
              opacity: 1,
            });
          }
        },
      },
    });
    timelineMars.addLabel('start');
  },
};
</script>

<style lang="scss">
.mars-section{
  position: relative;
  min-height: calc(var(--vh) * 140);

  .container{
    overflow: hidden;
    position: sticky;
    top: 250px;
  }

  .about{
    opacity: 0;
    color: #ffffff;
  }
}
.mars{
  top: -210px;
  right: -210px;
  max-width: 410px;
  width: 100%;
  position: fixed;
  opacity: 1;
  transform: scale(1.3);
}
.shuttle-container{
  position: relative;
  margin-top: 200px;
  padding-bottom: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%,
              rgba(#F4F4F4, 0) 58.11%, #F4F4F4 59.03%);

  .fire-block{
    position: absolute;
    bottom: 18%;
    max-width: 300px;
    display: flex;
    justify-content: space-between;
    width: 70%;
    height: 220px;
    overflow: hidden;
  }
  .fire{
    position: absolute;
    top: 0;
    z-index: 18;
    transform: rotate(180deg);

    &__1{
      left:20%;
      top: -10px;
      transform: rotate(180deg) scale(0.9);
    }
    &__2{
      z-index: 19;
      transform: translate(20px, 0) rotate(180deg) scale(1.1);
    }
    &__3{
      right:20%;
      top: -10px;
      transform: rotate(180deg) scale(0.9);
    }
  }
}
.shuttle{
  width: 100%;
  max-width: 540px;
  position: relative;
  top: 0;
  z-index: 20;
}

@media(max-width: 380px) and (max-height: 670px){
  .mars-section .container{
    top: 200px;
  }
}
@media(max-width: 360px){
  .mars-section .container{
    top: 160px;
  }
}
</style>
